import { UploadSource } from '../uploads/values/UploadSource';

export enum MediaType {
  video = 'video',
  image = 'image',
  link = 'link',
  gif = 'gif',
}

export type Media = {
  id?: string;
  url?: string;
  thumbnailUrl?: string;
  alt?: string;
  type: MediaType;
  size?: number;
  source?: UploadSource;
};

export type IdeaContent = {
  text?: string;
  media?: Media[];
};

export type Idea = {
  id: string;
  content: IdeaContent;
  createdAt?: number;
};

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;
export type NewIdea = Optional<Idea, 'id'>;

export const isExistingIdea = (idea: NewIdea): idea is Idea => {
  return !!idea?.id;
};

export type PostMediaValidity = {
  valid: boolean;
  message: string | null;
};

export enum IdeaEvents {
  IDEAS_DELETED = 'ideas_deleted',
  IDEA_UPDATED = 'idea_updated',
  IDEA_CREATED = 'idea_created',
}
